import React, { useState, useEffect, useRef } from "react";
import { Custom, Item, Progress } from "components";
import { useApp } from "context";
import { Box, Grid } from "@mui/material";
import { IService } from "interfaces";

type Props = {
  sx?: any;
  opened: boolean;
  onClose?: () => void;
  clinicId?: number | null;
  onClick?: (value: IService) => void;
};

export const Service = (props: Props) => {
  const { t, theme, service } = useApp();

  const [services, setServices] = useState<IService[] | null>(null);

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      servicesEffect();
      initialRender.current = false;
      return;
    }
    setServices(null);
    servicesEffect();
  }, [props.clinicId]);

  const servicesEffect = async () => {
    const services = props.clinicId
      ? await service.service.findByClinic(props.clinicId)
      : await service.service.all();
    setServices(services);
  };

  const handleServiceClick = (service: IService) => {
    props.onClick && props.onClick(service);
  };

  return (
    <Custom.Modal
      opened={props.opened}
      onClose={props.onClose}
      header={t.title.patient.service}
    >
      <>
        <Grid container sx={{ marginTop: theme.margin.md }}>
          <Grid item xs={12}>
            <Box sx={{ minHeight: 200, position: "relative" }}>
              <Grid container spacing={theme.margin.md}>
                {services ? (
                  services.length > 0 ? (
                    services.map((item: IService) => {
                      return (
                        <Grid item xs={4} sm={3} key={item.serviceId}>
                          <Item.Service
                            service={item}
                            onClick={() => handleServiceClick(item)}
                          />
                        </Grid>
                      );
                    })
                  ) : (
                    <Progress.NoRecord />
                  )
                ) : (
                  <Progress.PageProcess />
                )}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </>
    </Custom.Modal>
  );
};
